import { axios } from 'libs';

const resource = '/cep';

export const buscarCep = cep => axios.get(`${resource}/${cep}`);
